import { getItemFromCollection } from "directus/src/operations";

export async function fetchCostMasterData({ costmasterId }) {
  try {
    const response = await getItemFromCollection("cost_master", costmasterId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
